import { Component, OnInit,Inject } from '@angular/core';
import {MatDialog, MatDialogRef } from '@angular/material';
import {MAT_DIALOG_DATA} from '@angular/material';
import { NestService } from '../../services/nest.service';

@Component({
  selector: 'app-adduserpet',
  templateUrl: './adduserpet.component.html',
  styleUrls: ['./adduserpet.component.css']
})
export class AdduserpetComponent implements OnInit {
  userid: any;
  bio = 'About Me';
  image:any;
  dob:any;
  pname:any;
  ptype:any;
  loading:any;
  constructor(@Inject(MAT_DIALOG_DATA) public data , public dialogRef: MatDialogRef<AdduserpetComponent>,
  private nestService: NestService) {
    this.userid = data.uid;
   }

  ngOnInit() {
  }
  createPet(){
    if(this.ptype == 'dog'){
      this.image = 'dogavatar.png';
    }else if(this.ptype == 'cat'){
      this.image = 'catavatar.png';
    }
    this.loading= true;
    this.nestService.createuserpet(this.userid,this.pname,this.ptype,this.bio,this.dob,this.image)
    .subscribe(
      (x)=>{
        this.loading = false;
        this.addPet(x);
      });
  }
  addPet(p){
    this.dialogRef.close(p);
  }
}
